import { Route } from '@angular/router';

import { Auth2faGuard, AuthRoutes } from '@bn/auth';
import { AuthLayoutComponent, ResetPasswordPage, TwoFactorAuthPage } from '@bn/auth-pages';

import { AppRoutes } from './core/enums/app-routes.enum';
import { CustomerRoutes } from './core/enums/customer-routes.enum';
import { partnerAuthGuard } from './core/guards';
import { PartnerStore } from './core/stores';
import { LayoutComponent } from './layout/layout.component';
import { customerContractGuard } from './pages/customer/customer-contract.guard';
import { CustomerTab } from './pages/customer/customer-tab.enum';
import { PartnerCustomerStore } from './pages/customer/stores';

export const appRoutes: Route[] = [
  {
    path: AuthRoutes.Auth,
    component: AuthLayoutComponent,
    children: [
      {
        path: AuthRoutes.Login,
        loadComponent: () => import('./pages/login/login.page').then((m) => m.LoginPage),
      },
      {
        path: AuthRoutes.ResetPassword,
        component: ResetPasswordPage,
      },
      {
        path: AuthRoutes.TwoFactorAuth,
        component: TwoFactorAuthPage,
        canActivate: [Auth2faGuard],
      },
    ],
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [partnerAuthGuard],
    providers: [PartnerCustomerStore, PartnerStore],
    children: [
      { path: '', pathMatch: 'full', redirectTo: AppRoutes.Overview },
      {
        path: AppRoutes.Overview,
        loadComponent: () => import('./pages/customers/customers-list.page').then((m) => m.CustomersListPage),
      },
      {
        path: CustomerRoutes.AddCustomer,
        loadComponent: () => import('./pages/customers/pages/add-customer/add-customer.page').then((m) => m.AddCustomerPage),
      },
      {
        path: CustomerRoutes.InviteCustomer,
        loadComponent: () => import('./pages/customers/pages/invite-customer/invite-customer.page').then((m) => m.InviteCustomerPage),
      },
      {
        path: AppRoutes.Pricing,
        loadComponent: () => import('./pages/pricing/pricing.page').then((m) => m.PricingPage),
      },
      {
        path: AppRoutes.Contract,
        loadComponent: () => import('./pages/contract/contract.page').then((m) => m.ContractPage),
      },
      {
        path: `${AppRoutes.Overview}/:customerId`,
        loadComponent: () => import('./pages/customer/customer.page').then((m) => m.CustomerPage),
        children: [
          {
            path: '',
            pathMatch: 'full',
            loadComponent: () => import('./pages/customer/tabs/overview/customer-overview.page').then((m) => m.CustomerOverviewPage),
          },
          {
            path: CustomerTab.Contract,
            canActivate: [customerContractGuard],
            loadComponent: () => import('./pages/customer/tabs/contract/customer-contract.page').then((m) => m.CustomerContractPage),
          },
          // Products enable/disable is OOS until the scoped API key work is done — restore this route then.
          // {
          //   path: CustomerTab.Products,
          //   loadComponent: () => import('./pages/customer/tabs/products/customer-products.page').then((m) => m.CustomerProductsPage),
          // },
          {
            path: CustomerTab.Pricing,
            loadComponent: () => import('./pages/customer/tabs/pricing/customer-pricing.page').then((m) => m.CustomerPricingPage),
          },
          {
            path: CustomerTab.Billing,
            loadComponent: () => import('./pages/customer/tabs/billing/customer-billing.page').then((m) => m.CustomerBillingPage),
          },
          {
            path: CustomerTab.AuditLogs,
            loadComponent: () => import('./pages/customer/tabs/audit-logs/customer-audit-logs.page').then((m) => m.CustomerAuditLogsPage),
          },
        ],
      },
    ],
  },
  { path: '**', redirectTo: '' },
];
